import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { accountByIdUrl, accountUrl } from '../../shared/helpers/endPoints';
import {
    ADD_ACCOUNT,
    DELETE_BANK_ACCOUNT_BY_MERCHANT,
    GET_BANK_ACCOUNT_BY_MERCHANT,
    UPDATE_BANK_ACCOUNT_BY_MERCHANT
} from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';

import { setError, setModal, setProcessLoading, setSuccess } from '../utils/action';
import { getBankAccountByMerchant, setAccount, setBankDelete, setUpdateBankAccount } from './action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';

function* callAddAccounts({ payload: value }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: accountUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(value)
        };

        yield call(fetchJSON, options);

        // yield put(setUpdateBankAccount(response.data));
        yield put(setSuccess('You have successfully added your bank details'));
        // After a successful response call get bank account
        yield put(getBankAccountByMerchant({ merchantId: value.merchantId }));

        yield put(setModal({ addNewBankModal: false, error: '' }));
        yield put(setProcessLoading(false));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}

function* callGetBankAccountByMerchant({ payload: value }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: accountUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            params: value
        };

        const response = yield call(fetchJSON, options);
        yield put(setAccount(response.data));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
    }
}

function* callUpdateAccounts({ payload: { bankAccountId, value } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: accountByIdUrl(modeType, bankAccountId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(value)
        };

        const response = yield call(fetchJSON, options);
        yield put(setUpdateBankAccount(response.data));
        yield put(setSuccess('You have successfully updated your bank details'));
        yield put(setModal({ updateBankModal: false, error: '' }));
        yield put(setProcessLoading(false));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}
function* callDeleteBankAccounts({ payload: { bankAccountId } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'DELETE',
            url: accountByIdUrl(modeType, bankAccountId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        yield call(fetchJSON, options);

        yield put(setSuccess('You have successfully deleted a bank account'));
        yield put(setBankDelete(bankAccountId));
        yield put(setModal({ deleteBankAccountModal: false }));
        yield put(setProcessLoading(false));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}
export function* watchCallAddAccount() {
    yield takeEvery(ADD_ACCOUNT, callAddAccounts);
}
export function* watchCallGetBankAccountByMerchant() {
    yield takeEvery(GET_BANK_ACCOUNT_BY_MERCHANT, callGetBankAccountByMerchant);
}
export function* watchCallUpdateBankAccountByMerchant() {
    yield takeEvery(UPDATE_BANK_ACCOUNT_BY_MERCHANT, callUpdateAccounts);
}
export function* watchCalDeleteBankAccountByMerchant() {
    yield takeEvery(DELETE_BANK_ACCOUNT_BY_MERCHANT, callDeleteBankAccounts);
}

function* profileSaga() {
    yield all([
        fork(watchCallAddAccount),
        fork(watchCallGetBankAccountByMerchant),
        fork(watchCallUpdateBankAccountByMerchant),
        fork(watchCalDeleteBankAccountByMerchant)
    ]);
}

export default profileSaga;
